import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    name: null, // Tên loại câu hỏi
    icon: null, // Icon
    created_time: null, // Thời điểm tạo
    creator_id: null, // Người tạo
};

// validation form
model.validForm = {
    name: [ValidService.required], // Tên loại câu hỏi
    icon: [ValidService.required], // Icon
    created_time: [], // Thời điểm tạo
    creator_id: [],
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
};

// validation các form khác
model.validFormOther = {
};


model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["created_time", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            name: '',
        },
        valid: {
            name: [],
        },
        operator: {
            name: ':regex_i:',
        }
    }
};

export default model;